import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { getIconColor } from './lights_local_actions_view';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';
import type { LabelProps } from '@Shelly/shelly-design-system/index';

export const buildCuryLabels = (
	method: string,
	job: ActionJob,
	labelList: LabelProps[],
): LabelProps[] => {
	const $format = get(format);
	if (/^(cury.boost)$/.test(method)) {
		labelList.push({
			icon: 'fas fa-fire',
			iconColor: '--color-primary',
		});
	}
	if (job.params?.slot != null) {
		if (job.params?.on != null) {
			labelList.push({
				value:
					job.params.on == true
						? $format('on_action', { default: 'on' })
						: $format('off_action', { default: 'off' }),
				icon: `fas fa-toggle-${job.params.on === true ? 'on' : 'off'}`,
				iconColor: job.params.on === true ? '--color-success' : '--color-danger',
			});
		}
		labelList.push({
			value:
				job.params.slot === 'left'
					? $format('label_intensity_left', {
							default: 'Intensity left',
						})
					: $format('label_intensity_right', {
							default: 'Intensity right',
						}),
		});
		if (job.params?.intensity != null) {
			labelList.push({
				value: `${job.params.intensity}%`,
				icon: 'fas fa-spray-can',
			});
		}
	}
	if (/^(cury.setconfig)$/.test(method) && job.params?.config?.ambient) {
		const ambient = job.params.config.ambient;
		if (ambient?.brightness != null) {
			labelList.push({
				value: `${ambient.brightness}%`,
				icon: 'fas fa-sun',
			});
		}
		if (ambient?.color != null || ambient?.enable != null) {
			const iconColor = getIconColor(ambient?.color);
			const isOn = ambient?.enable === true;

			labelList.push({
				value: $format('label_ambient_light', {
					default: 'Ambient light',
				}),
				icon: isOn
					? 'fas fa-lightbulb-on'
					: iconColor
						? 'fa-duotone fa-light fa-lightbulb'
						: 'fas fa-lightbulb',
				...(iconColor &&
					!isOn && {
						iconStyle: `--fa-primary-color: ${iconColor}; --fa-secondary-color: ${iconColor}; --fa-secondary-opacity: 1`,
					}),
			});
		}
		if (ambient?.use_vial_color != null) {
			labelList.push({
				value: $format('label_use_vial_color', {
					default: 'Use vial color',
				}),
				icon: `fas fa-toggle-${ambient.use_vial_color === true ? 'on' : 'off'}`,
				iconColor: ambient.use_vial_color === true ? '--color-success' : '--color-danger',
			});
		}
	}
	return labelList;
};

export const stringifyCuryAction = (method: string, action: ActionJob): string => {
	const $format = get(format);
	const params = action.params;
	let actionStringify = '';
	if (/^cury.boost$/.test(method)) {
		actionStringify += ` ${$format('sub_settings_title_boost', {
			default: 'Boost',
		})} `;
	} else if (params.on != null) {
		actionStringify += `${$format('label_cury_state', {
			default: 'Cury State',
		})}: ${
			params.on == true
				? $format('on_action', { default: 'on' })
				: $format('off_action', { default: 'off' })
		} , `;
	}
	if (params.slot != null) {
		actionStringify +=
			(params.slot === 'left'
				? $format('label_intensity_left', {
						default: 'Intensity left',
					})
				: $format('label_intensity_right', {
						default: 'Intensity right',
					})) + ' , ';
		if (params.intensity != null) {
			actionStringify += `${params.intensity}% , `;
		}
	}
	if (/^(cury.setconfig)$/.test(method) && params?.config?.ambient) {
		const ambient = params?.config?.ambient;
		if (ambient && ambient.brightness != null) {
			actionStringify += `${$format('label_brightness', {
				default: 'Brightness',
			})}: ${ambient.brightness}% , `;
		}
		const iconColor = getIconColor(ambient?.color);
		if (ambient && iconColor) {
			actionStringify += `${$format('label_color', {
				default: 'Color',
			})}: <i class="fas fa-lightbulb${ambient?.enable === true ? '-on' : ''}" style="color:rgb(${iconColor});margin:0 5px;display:inline-block"></i> , `;
		}
		if (ambient && ambient.enable != null) {
			actionStringify += `${$format('label_ambient_light', {
				default: 'Ambient light',
			})}: ${
				ambient.enable === true
					? $format('on_action', { default: 'on' })
					: $format('off_action', { default: 'off' })
			} , `;
		}
		if (ambient && ambient.use_vial_color != null) {
			actionStringify += `${$format('label_use_vial_color', {
				default: 'Vial color',
			})}: ${
				ambient.use_vial_color === true
					? $format('on_action', { default: 'on' })
					: $format('off_action', { default: 'off' })
			} , `;
		}
	}
	return actionStringify;
};
